'use client'
import { useSelector } from 'shared-redux'
import { selectedCartProductQuantities } from 'shared-redux/state'

/**
 * Units of each product already in the cart, keyed by product id.
 *
 * Lets a surface that is not a cart line still reason about what the shopper
 * holds — a product card advertising a volume tier is far more useful saying
 * "two more and you save 5%" than "buy 10 and save 5%" to someone who already
 * has eight.
 *
 * The map itself is memoised in the selector, so the basket is walked once per
 * cart change no matter how many cards are mounted; each caller does an O(1)
 * lookup. Counts bundled units too — see `selectedCartProductQuantities`.
 */
export const useCartQuantities = (): Map<string, number> =>
  useSelector(selectedCartProductQuantities)

/** Convenience for the single-product case. `0` when the cart holds none. */
export const useCartQuantity = (productId: string): number =>
  useCartQuantities().get(productId) ?? 0
